import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';

export type SvgSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

@Component({
  selector: 'lh-shared-ui-svg-icon',
  imports: [SvgIconComponent],
  template: `
    <svg-icon
      [key]="key()"
      class="!tw-flex tw-items-center tw-justify-center tw-m-auto tw-inset-0 tw-leading-none"
      [color]="color()"
      [size]="size()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiSvgIconComponent {
  public key = input.required<SvgIcons>();
  public size = input<SvgSize>('lg');
  public color = input<string>('currentColor');
}
